import { cn } from "../../utils/cn";

export const Kdb = ({ name, className }: { name: string | React.ReactNode; className?: string }) => {
  return (
    <kbd
      className={cn(
        "typo-body-base-regular inline-flex min-h-7 items-center justify-center rounded-md border border-neutral-200 bg-neutral-0 px-1.5 py-1 text-font-primary shadow-[0px_2px_0px_0px_rgba(0,0,0,0.08)] transition hover:translate-y-0.5 hover:shadow-none group-hover/select-item:translate-y-0.5 group-hover/select-item:shadow-none",
        // oxlint-disable-next-line grafit-oxlint/no-tailwind-font-classes -- key caps keep a monospace face, no typo-* token for it
        "font-mono",
        className,
      )}
    >
      {name}
    </kbd>
  );
};
